class InvoiceFormModalController extends AbstractController
	@register()
	@inject '$uibModalInstance',
		'CopyService',
		'InvoiceRepository',
		'InvoiceFormModalService',
		'ConfigurationService',
		'Guid',
		'invoiceStatuses',
		'invoiceStatusEnum': 'BACKEND_INVOICE_STATUS',
		'BACKEND_TRANSACTION_PAYMENT_TYPE',
		'invoice',
		'defaultCurrency'

	initialize: ->
		@isNewEntity = _.isEmpty @invoice
		@initializeMode()
		@initializeCommonData()
		@initializeStatuses()
		@initializePaymentAccount()

	initializeMode: ->
		if @isNewEntity
			@invoiceData = @InvoiceFormModalService.prepareInvoiceBaseData()
			@invoiceData.status = @invoiceStatusEnum.DRAFT
			@invoiceData.currency = @defaultCurrency if @defaultCurrency?
			@invoiceData.invoice_number = @generateInvoiceNumber()
			@orders = []
			@useInterval = true
			@interval = null
			@canEdit = true
			@isPaid = false
			@saveButtonText = 'general.invoice.issue_new'
		else
			@invoiceData = angular.copy @invoice
			@orders = @InvoiceFormModalService.extractOrdersFromInvoice(@invoice)
			@initialStatus = @invoice.status
			@canEdit = @initialStatus == @invoiceStatusEnum.DRAFT
			@isPaid = @initialStatus == @invoiceStatusEnum.PAID
			@useInterval = false
			@saveButtonText = 'general.save'

	initializeCommonData: ->
		@intervalDatePickerConfiguration = @InvoiceFormModalService.createIntervalDatePickerConfig()
		@datePickerConfiguration = @InvoiceFormModalService.createDatePickerConfig()

	initializeStatuses: ->
		@invoiceStatuses = @CopyService.copy(@invoiceStatuses)

		if @isNewEntity
			@invoiceStatuses = @InvoiceFormModalService.filterInvoiceStatuses(
				@invoiceStatuses,
				[@invoiceStatusEnum.PAID]
			)
		else if @invoice.status == @invoiceStatusEnum.ISSUED
			for status in @invoiceStatuses
				status.disabled = status.id == @invoiceStatusEnum.DRAFT

	initializePaymentAccount: ->
		if @isNewEntity
			@paymentAccount =
				number: @ConfigurationService.getValue('Backoffice.Sales.PaymentAccount.Number')
				details: @ConfigurationService.getValue('Backoffice.Sales.PaymentAccount.Details')

	findOrders: (search) ->
		excludeOrderIds = _.pluck(@orders, 'id')

		@InvoiceFormModalService.findOrders(
			search,
			@invoiceData.customer_id,
			excludeOrderIds,
			@BACKEND_TRANSACTION_PAYMENT_TYPE.INVOICE
		)

	save: ->
		if @isNewEntity
			@issueInvoice()
		else
			@updateInvoice()

	issueInvoice: ->
		data = _.clone(@invoiceData)

		if @useInterval
			data.interval = @interval
		else
			data.order_ids = _.pluck(@orders, 'id')

		@InvoiceRepository
			.post('', data)
			.finally =>
				@$uibModalInstance.close(true)

	updateInvoice: ->
		data = @prepareUpdateData()

		if !data
			return

		@InvoiceRepository
			.patch(@invoice.id, data)
			.then (response) =>
				@invoice = response.data

				request = @prepareUpdateOrdersRequest()

				if !request
					@$uibModalInstance.close(true)
					return

				request.finally =>
					@$uibModalInstance.close(true)

	prepareUpdateData: ->
		if @initialStatus == @invoiceStatusEnum.DRAFT
			return {
				status: @invoiceData.status
				due_date: @invoiceData.due_date
				currency: @invoiceData.currency
				issue_date: @invoiceData.issue_date
				invoice_number: @invoiceData.invoice_number
				customer_id: @invoiceData.customer_id
			}
		else if @initialStatus == @invoiceStatusEnum.ISSUED
			return {
				status: @invoiceData.status
			}
		else
			return null

	prepareUpdateOrdersRequest: ->
		if @initialStatus != @invoiceStatusEnum.DRAFT
			return null

		if @useInterval
			return @InvoiceRepository.patch(@invoice.id + '/add_orders_by_interval', {interval: @interval})

		return @InvoiceRepository.patch(
			@invoice.id + '/set_orders',
			{order_ids: _.uniq(_.pluck(@orders, 'id'))}
		)

	cancel: ->
		@$uibModalInstance.dismiss(false)

	showInterval: ->
		return @useInterval && !_.isEmpty @invoiceData.customer_id

	showUseInterval: ->
		return !_.isEmpty(@invoiceData.customer_id) && (@isNewEntity || @initialStatus == @invoiceStatusEnum.DRAFT)

	showOrders: ->
		return @isNewEntity && !@useInterval && !_.isEmpty @invoiceData.customer_id

	showOrdersInEdit: ->
		return !@isNewEntity && @canEdit && !@useInterval

	showPaymentAccount: ->
		return @isNewEntity

	canChangeStatus: ->
		return !@isPaid

	isInvoiceValid: ->
		isValid = !!@invoiceData.currency && !!@invoiceData.status && !!@invoiceData.customer_id

		if !@useInterval
			isValid = isValid && @orders?.length > 0

		if @useInterval
			isValid = isValid && !!@interval?.from && !!@interval?.to

		return isValid

	onCustomerChange: ->
		@orders = []

	generateInvoiceNumber: ->
		return "INV-#{@Guid.generate().replace(/-/g, '').substring(0, 26)}"

